import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import { LayoutService } from '@app/shared/layout/layout.service';
import { UserService } from '@app/core/services';
import { CommonService } from '@app/shared/common/common.service';
import { I18nService } from '@app/shared/i18n';
import { environment } from '@env/environment';
import { Subscription } from 'rxjs';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { NotificationService } from '@app/shared/utils/notification.service';
import moment from 'moment';

declare var $: any;

@Component({
  selector: 'sa-userticket',
  templateUrl: './user-ticket.component.html',
  styleUrls:['./user-ticket.component.scss']
})
export class UserTicketComponent implements OnInit {

  langChangeSubscription: Subscription;
  lanId: string;
  langaugeChanged: boolean = false;
  ticketOptions: {};
  model: any = {};
  ticketForm: UntypedFormGroup = new UntypedFormGroup({});
  ticketFields: Array<FormlyFieldConfig> = [];
  options;
  client: any;
  errorMessage = '';
  loadForm: boolean;
  langLoading: boolean = true;
  constructor(private router: Router,private layoutService: LayoutService,private i18nService: I18nService,private commonService: CommonService,private userService:UserService
    ,private httpClient: HttpClient,private notificationService: NotificationService
    ) {
    this.langChangeSubscription = this.i18nService.langChangeEvent.subscribe(langObj => 
      setTimeout(() => {
        this.onLangChange(langObj);
      },500));
      
      // var self = this;
      // $(window).resize(function () {
      //   self.fluidDialog();
      // });
  }
 

  ngOnInit() {
    this.initTicketPopup();
    this.initTicketData()
    this.langChangeSubscription = this.i18nService.langChangeEvent.subscribe(langObj => this.onLangChange(langObj));
  }
  // onLangChange(langObj: any) {
  //   langObj.isHandled = true;
    
  //   if( this.langaugeChanged ){
  //     this.lanId = this.commonService.getCurrentLanguageCode();
      
  //   }
    
  //   this.langaugeChanged = true;
  // }
  onLangChange(langObj) {
    this.loadForm = false;
    this.lanId = this.commonService.getCurrentLanguageCode();
    moment.locale(this.lanId);
    if (!this.langLoading) {
      this.initTicketData();
      this.initTicketPopup();
    }
    else {
      this.initTicketData();
      this.initTicketPopup();
    }

    // setTimeout(() => {
    //   this.initDatePicker();
    // });
    langObj.isHandled = true;
    this.loadForm = true;
    this.langLoading = false;
  }
  showPopup(){
    $("#ticketPopup").dialog("open");
  }
  ngOnDestroy() {
    $("#ticketPopup").dialog('destroy');
  }
  initTicketPopup() {
    var headers = this.i18nService.getTranslation("common_new_ticket");
    this.ticketOptions = {
      autoOpen: false,
      modal: true,
      dialogClass: 'serviceTheme ticketPopupImportant',
      width: window.innerWidth > 767 ? 750 : '90%',
      // width: 'auto',
      maxWidth: 1200,
      resizable: false,
      // fluid: true, //new option
      closeText: '',
      open: () => {
        // this.fluidDialog();
        this.options.formState.submitted=false;
        $('#summernote').summernote('code', '')
        // this.stepsService.setserviceData(this.contentForm.value);
      },
      close: (() => {
        this.initTicketData();
        // this.cancelService();
      //   if(Object.keys(this.stepsService.serviceModel).length!=0){
      //     Object.keys(this.stepsService.serviceModel).forEach(ele=>{
      //       let model=this.stepsService.serviceModel
      //       this.contentForm.value[ele]=model[ele];
      //     })
      //   }
      }),
      title: "<div class='widget-header'><h1 class='headticket'>" + headers + "</h1></div>",
    };
    $("#ticketPopup").dialog(this.ticketOptions);
  }
  // fluidDialog() {
  //   var $visible = $(".ui-dialog:visible");
  //   // each open dialog
  //   $visible.each(function () {
  //     var $this = $(this);
  //     var dialog = $this.find(".ui-dialog-content").data("ui-dialog");
  //     // if fluid option == true
  //     if (dialog.options.fluid) {
  //       var wWidth = $(window).width();
  //       // check window width against dialog width
  //       if (wWidth < (parseInt(dialog.options.maxWidth) + 50)) {
  //         // keep dialog from filling entire screen
  //         $this.css("max-width", "90%");
  //       } else {
  //         // fix maxWidth bug
  //         $this.css("max-width", dialog.options.maxWidth + "px");
  //       }
  //       //reposition dialog
  //       dialog.option("position", dialog.options.position);
  //     }
  //   });

  // }
  
  cancel(){
    this.options.resetModel();
    this.model = {
      contactName:'',
      email: '',
      cc: '',
      ccc: true,
      subject: '',
      subject1: '',
      description: '',
      date: '',
    };
    this.ticketForm.reset();
  }
  initTicketData() {
    var self = this;
    let userfields: Array<FormlyFieldConfig> = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            className: 'col-sm-12 col-lg-12 col-xs-12',
            key: 'companyName',
            type: 'input',
            templateOptions: {
              required: true,
              label: this.i18nService.getTranslation('common_company_name'),
              placeholder: this.i18nService.getTranslation('common_required'),
              type: 'text',
              addonRight: {
                class: 'fa fa-university',
              },
            },
            validators: {
              validation: [Validators.required]
            },
          }
        ],
      },
      {
        fieldGroupClassName: 'row',
        fieldGroup: [{
          className: 'col-sm-6 col-lg-6 col-xs-12',
          key: 'contactName',
          type: 'input',
          templateOptions: {
            required: true,
            label: this.i18nService.getTranslation('ticket_contact_person'),
            placeholder: this.i18nService.getTranslation('common_required'),
            type: 'text',
            addonRight: {
              class: 'fa fa-user',
            },
          },
          validators: {
            validation: [Validators.required]
          },
        },
        {
          className: 'col-sm-6 col-lg-6 col-xs-12',
          key: 'email',
          type: 'input',
          templateOptions: {
            required: true,
            label: this.i18nService.getTranslation('common_email'),
            placeholder: this.i18nService.getTranslation('common_required'),
            type: 'text',
            addonRight: {
              class: 'fa fa-envelope',
            },
          },
          validators: {
            validation: [Validators.required]
          },
        }
        ],
      },
      {
        fieldGroupClassName: 'row',
        fieldGroup: [{
          className: 'col-sm-12 col-lg-6 col-xs-12',
          key: 'cc',
          type: 'input',
          templateOptions: {
            required: true,
            label: this.i18nService.getTranslation('common_cc'),
            placeholder: this.i18nService.getTranslation('common_required'),
            type: 'text',
            addonRight: {
              class: 'fa fa-envelope',
            },
          },
          validators: {
            validation: [Validators.required]
          },
        },
        {
          className: 'col-sm-12 col-lg-6 col-xs-12 pt-5',
          key: 'ccc',
          type: 'checkbox',
          templateOptions: {
            label: this.i18nService.getTranslation('Write_in_cc'),
            "options": [
              {
                "name": "Active",
                "value": "1"
              },
              {
                "name": "Inactive",
                "value": "0"
              }
            ]
          },
        },
        
        ],
      },
      {
        fieldGroupClassName: 'row',
        fieldGroup: [{
          className: 'col-sm-12 col-lg-6 col-xs-12',
          key: 'subject',
          type: 'input',
          templateOptions: {
            required: true,
            label: this.i18nService.getTranslation('ticket_subject'),
            placeholder: this.i18nService.getTranslation('common_required'),
            type: 'text',
            addonRight: {
              class: 'fa fa-info',
            },
          },
          validators: {
            validation: [Validators.required]
          },
        },
        {
          className: 'col-sm-12 col-lg-6 col-xs-12',
          type: 'select',
          key: 'priority',
          templateOptions: {
            required: true,
            options: [{
              label: "Low",
              value: "Low",
            }, 
            {
              label: "Normal",
              value: "Normal",
            },
            {
              label: "High",
              value: "High",
            }],
            label: this.i18nService.getTranslation('ticket_priority'),
            placeholder: this.i18nService.getTranslation('common_please_select'),
            addonRight: {
              class: 'fas fa-university',
            },
          },
          validators: {
            validation: [Validators.required]
          }
        },
        ],
      },
      {
        fieldGroupClassName: 'row',
        fieldGroup: [{
          className: 'col-sm-12 col-lg-6 col-xs-12 dateField',
          type: 'input',
          key: 'date',
          templateOptions: {
            label: this.i18nService.getTranslation('ticket_date'),
            placeholder: this.i18nService.getTranslation('common_required'),
            type: 'text',
            required: true,
            disabled: false,
            addonRight: {
              class: 'fas fa-calendar',
            },
          },
        }
      ],
      },
      ];

    setTimeout(() => {
      this.ticketForm.removeControl('companyName');
      this.ticketForm.removeControl('contactName');
      this.ticketForm.removeControl('email');
      this.ticketForm.removeControl('cc');
      this.ticketForm.removeControl('ccc');
      this.ticketForm.removeControl('subject');
      this.ticketForm.removeControl('priority');
      this.ticketForm.removeControl('date');
      this.ticketFields = userfields;
      setTimeout(() => {
        this.initDatePickers()
      });
    });
      this.model = {
        contactName:'',
        email: '',
        cc: '',
        ccc: true,
        subject: '',
        date: '',
      };

    this.options = {
      formState: {
        submitted: '',
      },
    };
  }
  initDatePickers() {
    $(".dateField input").datepicker({
      defaultDate: "+1w",
      yearRange: "-100:+0",
      changeMonth: true,
      changeYear: true,
      prevText: '<i class="fa fa-chevron-left"></i>',
      nextText: '<i class="fa fa-chevron-right"></i>',
      onSelect: (selectedDate) => {
        this.ticketForm.controls['date'].setValue(selectedDate);
      },
      beforeShow: function (input, inst) {
        $('#ui-datepicker-div').addClass('popupdatepicker');
        $('#ui-datepicker-div').addClass('ticketPopupClass');
      },
      dateFormat: 'yy-mm-dd'
    });
    $(".dateField input").attr('autocomplete', 'off');
    this.lanId = this.commonService.getCurrentLanguageCode()
    setTimeout(() => {
      this.model["date"] ? $(".dateField input").datepicker("setDate", new Date(this.model["date"])) : "";
      $(".dateField input").datepicker("option", $.datepicker.regional[this.lanId]);
    });
  }

  // test(){
  //   let clientserver;
  //   var url = 'http://api.ticket.g2bngt.io-procurement.com/ws/createTicketFromGate2B.cfc?wsdl';
  //   // alert()
  // //   this.soap.createClient(url, function(err, client) {
  // //     client.createTicketFromGate2B('', function(err, result) {
  // //         console.log(result);
  // //     });
  // // });
  // this.soap.createClient(url).then(client => {
  // this.client = client;
  // this.client.createTicketFromGate2B('').subscribe(data=>{console.log(data);
  //   console.log(data);
    
  // })
  // return this.httpClient.post('http://lucee.ticket:8888/ws/createTicketFromGate2B.cfc?wsdl&method=createTicketFromGate2B',data).pipe(map((responseData: CommonDataStrecture)=>responseData));
  // // (<any>this.client).createTicketFromGate2B('body').subscribe((res: ISoapMethodResponse) => {console.log(res);
  // // });
  // console.log(this.client);
  
  // });
    
  // }
  submit(){
    this.options.formState.submitted=false;
    var aHTML = $('#summernote').summernote('code');
    aHTML= aHTML.replace(/\&nbsp;/g,' ')
    aHTML= aHTML.trim()

    if(aHTML.substring(0,3)=='<p>')
    {
       aHTML= aHTML.replace('<p>','');
       aHTML= aHTML.trim();

       aHTML='<p>'+aHTML;
    }
    let formData = new FormData();
    formData.append("contactName", this.ticketForm.value.contactName);
    formData.append("contactEmail", this.ticketForm.value.email);
    formData.append("cc", this.ticketForm.value.cc);
    // formData.append("ccc", this.ticketForm.value.ccc);
    formData.append("subject", this.ticketForm.value.subject);
    formData.append("priority", this.ticketForm.value.priority);
    // formData.append("date", this.ticketForm.value.date);
    formData.append("companyName", this.ticketForm.value.companyName);
    formData.append("description", aHTML);
    // this.httpClient.post(environment.ticket_URL,formData).subscribe(responseData=>{
    //   let data = responseData!=""? JSON.parse(responseData.toString()) :'';
    //   if(data != ""){
    //     if(data['DATA']['ticketNumber']!=""){
    //       this.notificationService.smallBox({
    //         title: '<b>'+this.i18nService.getTranslation('common_success')+'</b>',
    //         content: this.i18nService.getTranslation('ticket_created'),
    //         color: "#739e73",
    //         timeout: 2000
    //       });
    //       this.cancel();
    //       $("#ticketPopup").dialog('close');
    //     }
    //     else{
    //       this.notificationService.smallBox({
    //         title: '<b>'+this.i18nService.getTranslation('common_failure')+'</b>',
    //         content: this.i18nService.getTranslation('failed to create Ticket'),
    //         color: "#c46a69",
    //         timeout: 2000
    //       });
    //     }  
    //   }
    // });
  }
}
